import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'

import { ButtonComponent, Card, NoData } from 'components'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'components/Table'

import helpers from 'helpers'
import theme from 'theme'

const InvolvedPreRegistrationsTable = ({
  paymentContractPreRegistrations,
  handleBackPage,
  handleBackStep,
  show = false,
  button = false,
}) => {
  const isEmpty = !paymentContractPreRegistrations?.length

  return (
    <>
      <Card title="Empresas" fromTable>
        {isEmpty ? (
          <NoData message="Nenhuma empresa vai entrar no fluxo de churn, somente o contrato." />
        ) : (
          <Table emptyMessage="Nenhuma empresa encontrada.">
            <TableHead>
              <TableRow>
                <TableCell width="20%">Tipo</TableCell>
                <TableCell width="40%">Organização</TableCell>
                <TableCell width="20%">Documento</TableCell>
                <TableCell width="20%" align="center">
                  Status
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paymentContractPreRegistrations?.map((item) => (
                <TableRow key={item?.id}>
                  <TableCell>{item?.kindLabel}</TableCell>
                  <TableCell>{item?.preRegistration?.name}</TableCell>
                  <TableCell>
                    {helpers.formatters.document.identify(
                      item?.preRegistration?.document,
                    )}
                  </TableCell>
                  <TableCell align="center">{item?.statusLabel}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Card>
      {button && (
        <Box
          display="flex"
          justifyContent="flex-end"
          gridGap={theme.spacing(2)}
        >
          <ButtonComponent
            variant="outlined"
            color="primary"
            onClick={handleBackStep}
            title="Voltar"
          />
          <ButtonComponent
            variant="contained"
            color="primary"
            onClick={handleBackPage}
            title={show ? 'Fechar' : 'Confirmar'}
          />
        </Box>
      )}
    </>
  )
}

InvolvedPreRegistrationsTable.propTypes = {
  paymentContractPreRegistrations: PropTypes.array,
  handleBackPage: PropTypes.func,
  handleBackStep: PropTypes.func,
  show: PropTypes.bool,
  button: PropTypes.bool,
}

export default InvolvedPreRegistrationsTable
